import { useTypedApiClient } from 'hooks/useTypedApiClient'
import { useMutation, useQueryClient } from '@tanstack/react-query'

interface useDeleteLEContactParams {
  id: number | null | undefined
}

interface useDeleteLEContactProps {
  onSuccess?: (data: undefined, variables: useDeleteLEContactParams) => void
  onError?: (error: Error, variables: useDeleteLEContactParams) => void
}

export const useDeleteLicensedEstablishmentContactById = ({
  onSuccess,
  onError,
}: useDeleteLEContactProps) => {
  const deleteLEContact = useTypedApiClient({
    path: '/admin/corporate-accounts/licensed-establishments/{id}',
    method: 'delete',
  })
  const queryClient = useQueryClient()

  return useMutation<any, Error, useDeleteLEContactParams>({
    mutationFn: async ({ id }: useDeleteLEContactParams) => {
      await deleteLEContact({ id: Number(id) })
    },
    onSuccess: async (data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: ['/admin/corporate-accounts/licensed-establishments/{id}'],
      })
      onSuccess?.(data, variables)
    },
    onError,
  })
}
